module.exports = __webpack_public_path__ + "static/media/Instructions_02_03_CTRF.a543cbb6.pdf";